export default "__VITE_ASSET__DaFjVPwy__"